module.exports = __webpack_public_path__ + "static/media/leg.377ed5cc.png";